import "./layoutModule.css";
import { useContext, useEffect } from "react";
import LogicContext from "../Context/LogicContext";
import { useNavigate, useLocation } from "react-router-dom";
import underscore from "underscore";
import { currentMenuListAtom } from "../store/storeMenuAtom";
import { useRecoilValue } from "recoil";
import { makeStyles } from "@mui/styles";

// MUI imports
import * as React from "react";
import { useTheme } from "@mui/material/styles";

import MenuIcon from "@mui/icons-material/Menu";
import UserNameItem from "../components/UserNameItem";

import NotificationPane from "./NotificationPane";
import GeneralSearchBar from "../components/GeneralSearchBar";
import SidebarModalTwo from "../components/ModuleSwitcher";
import DelgroLogoSVG from "../components/delgro_logo/DelgroLogoSVG";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { Disclosure } from "@headlessui/react";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "20%",
    background: "black",
    color: "white",
  },
  rootExpanded: {
    background: "black",
    flexGrow: 1,
  },
}));

const Userlayout = (props) => {
  const currentMenu = useRecoilValue(currentMenuListAtom);
  const logicContext = useContext(LogicContext);
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const { name } = props;
  const [expanded, setExpanded] = React.useState(false);
  const rootClass = expanded ? classes.rootExpanded : classes.root;

  const selectedMenu = underscore.pick(currentMenu, (value, key) => {
    return value["IsSetting_Menu"] === 0;
  });

  // Sequences come from the API as strings; missing/invalid ones sort last
  const toNum = (v) => (isNaN(Number(v)) ? Number.MAX_SAFE_INTEGER : Number(v));
  // Dashboard always stays at the top, whatever its parent sequence
  const isDashboard = (group) =>
    Number(group.items.some((m) => m.Function_Name?.toLowerCase() === "dashboard"));

  const menuGroups = Object.entries(underscore.groupBy(currentMenu, "Menu_Parent_Name"))
    .map(([name, items]) => ({
      name,
      items: [...items].sort(
        (a, b) => toNum(a.Menu_Print_sequence) - toNum(b.Menu_Print_sequence) || a.Menu_Id - b.Menu_Id
      ),
    }))
    .sort(
      (a, b) =>
        isDashboard(b) - isDashboard(a) ||
        toNum(a.items[0].Menu_Parent_Print_Sequence) - toNum(b.items[0].Menu_Parent_Print_Sequence) ||
        a.items[0].Menu_Parent_Id - b.items[0].Menu_Parent_Id
    );

  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const moduleSelectHandler = (selection) => {
    logicContext.moduleSelect(selection.Module_Id);
  };

  useEffect(() => {
    let timeoutId;
    if (!isNaN(currModuleId) && !selectedMenu[0]) {
      timeoutId = setTimeout(() => {
        logicContext.moduleSelect(currModuleId);
      }, 1000);
    }
    return () => {
      clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currModuleId]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const dynamicRoute = (route, menu) => {
    
    setOpen(false);
    const functionName = menu["Function_Name"];
    const menuRoute = functionName.replace(/_/g, "-");
    navigate(
      `/${currModuleId}/${currModuleName}/${menuRoute}`
    );
  };

  return (
    <div className="flex flex-row overflow-x-hidden">
      {/* Mobile View */}
      <div>
        <div className="sm:hidden h-screen bg-[#F5F5F5]">
          <Drawer open={open} onClose={handleDrawerClose} direction="left">
            <div className="bg-black z-50 pl-1 pt-1">
              <div className="w-full flex flex-row items-center justify-end p-1">
                <div
                  onClick={handleDrawerClose}
                  className="w-fit p-2 rounded-full hover:bg-gray-800 active:bg-gray-900 text-white cursor-pointer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18 18 6M6 6l12 12"
                    />
                  </svg>
                </div>
              </div>
              <div className="w-full flex justify-center">
                <DelgroLogoSVG />
              </div>
              <div className="flex flex-col overflow-y-scroll h-screen pb-[500px]">
                <div className="mt-4 mb-2 text-center text-base text-primary font-bold uppercase">
                  {currModuleName} 
                </div>
                <section className="h-[105vh]">
                  <ul className="space-y-1 text-white">
                    {menuGroups.map((group, i) => {
                      const isParent =
                        group.items[0]["IsParent_Menu"] === 1;
                      const menuIcon = require(`../assets/menu_icons/${
                        i + 1
                      }.png`);
                      const activeClass = (name) =>
                        currUserMenu?.toLowerCase() ===
                        name?.toLowerCase().replace(/_/g, "-")
                          ? "bg-blue-600 text-white"
                          : "hover:bg-blue-600/30";

                      return (
                        <li key={i}>
                          {isParent ? (
                            <div
                              className={`flex items-center px-3 py-2 rounded-sm text-sm font-medium cursor-pointer ${activeClass(
                                group.items[0]["Function_Name"]
                              )}`}
                              onClick={() =>
                                dynamicRoute(
                                  group.items[0]["Function_Name"],
                                  group.items[0]
                                )
                              }
                            >
                              <img
                                src={menuIcon}
                                alt=""
                                className="h-4 w-4 mr-3"
                              />
                              <span className="truncate max-w-32 text-white">
                                {group.items[0]["Menu_Name"]}
                              </span>
                            </div>
                          ) : (
                            <Disclosure>
                              {({ open }) => (
                                <>
                                  <Disclosure.Button
                                    className="flex w-full text-white items-center justify-between px-3 py-2 text-left text-sm font-medium rounded-sm hover:bg-blue-600/40"
                                    title={group.name.substring(0, 25)}
                                  >
                                    <div className="flex items-center">
                                      <img
                                        src={menuIcon}
                                        alt=""
                                        className="h-4 w-4 mr-3"
                                      />
                                      <span className="truncate text-white max-w-32">
                                        {group.name.substring(0, 25)}
                                      </span>
                                    </div>
                                    <div
                                      className={`${
                                        open ? "rotate-180 transform" : ""
                                      } text-white`}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="size-3.5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="m19.5 8.25-7.5 7.5-7.5-7.5"
                                        />
                                      </svg>
                                    </div>
                                  </Disclosure.Button>
                                  <Disclosure.Panel className="pl-6 pr-2 py-2 space-y-1">
                                    {group.items.map((subMenu, j) => {
                                      const isActive =
                                        currUserMenu?.toLowerCase() ===
                                        subMenu["Menu_Name"]
                                          ?.toLowerCase()
                                          .replace(/\s/g, "-");

                                      return (
                                        <div
                                          key={j}
                                          onClick={() =>
                                            dynamicRoute(subMenu["Function_Name"], subMenu)
                                          }
                                          title={subMenu["Menu_Name"]}
                                          className={`py-[3px] w-full`}
                                        >
                                          <span
                                            className={`ml-5 cursor-pointer font-medium text-xs transition-colors duration-200 max-w-[60px] truncate ${
                                              isActive
                                                ? "text-blue-600 w-full"
                                                : "text-white hover:text-blue-600/40 w-full"
                                            }`}
                                          >
                                            {subMenu["Menu_Name"]}
                                          </span>
                                        </div>
                                      );
                                    })}
                                  </Disclosure.Panel>
                                </>
                              )}
                            </Disclosure>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </section>
              </div>
            </div>
          </Drawer>
        </div>

        {/* Desktop View */}
        <div className="left-0 h-screen w-[195px] fixed z-50 hidden sm:inline bg-black">
          <div className="mt-2 flex items-center justify-center pb-2">
            <DelgroLogoSVG />
          </div>
          <div className="flex flex-col overflow-y-scroll h-screen pb-[500px]">
            <div className="mt-6 pb-4 text-center text-base text-primary font-bold uppercase">
              {currModuleName}
            </div>
            <section>
              <ul className="space-y-1 text-white">
                {menuGroups.map((group, i) => {
                  const isParent = group.items[0]["IsParent_Menu"] === 1;
                  const menuIcon = require(`../assets/menu_icons/${i + 1}.png`);
                  const activeClass = (name) =>
                    currUserMenu?.toLowerCase() ===
                    name?.toLowerCase().replace(/_/g, "-")
                      ? "bg-blue-600 text-white"
                      : "hover:bg-blue-600/30";

                  return (
                    <li key={i}>
                      {isParent ? (
                        <div
                          className={`flex items-center px-3 py-2 rounded-sm text-sm font-medium cursor-pointer ${activeClass(
                            group.items[0]["Function_Name"]
                          )}`}
                          onClick={() =>
                            dynamicRoute(
                              group.items[0]["Function_Name"],
                              group.items[0]
                            )
                          }
                        >
                          <img src={menuIcon} alt="" className="h-4 w-4 mr-3" />
                          <span className="truncate max-w-32 text-white">
                            {group.items[0]["Menu_Name"]}
                          </span>
                        </div>
                      ) : (
                        <Disclosure>
                          {({ open }) => (
                            <>
                              <Disclosure.Button
                                className="flex w-full text-white items-center justify-between px-3 py-2 text-left text-sm font-medium rounded-sm hover:bg-blue-600/40"
                                title={group.name.substring(0, 25)}
                              >
                                <div className="flex items-center">
                                  <img
                                    src={menuIcon}
                                    alt=""
                                    className="h-4 w-4 mr-3"
                                  />
                                  <span className="truncate text-white max-w-32">
                                    {group.name.substring(0, 25)}
                                  </span>
                                </div>
                                <div
                                  className={`${
                                    open ? "rotate-180 transform" : ""
                                  } text-white`}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="size-3.5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="m19.5 8.25-7.5 7.5-7.5-7.5"
                                    />
                                  </svg>
                                </div>
                              </Disclosure.Button>
                              <Disclosure.Panel className="pl-6 pr-2 py-2 space-y-1">
                                {group.items.map((subMenu, j) => {
                                  const isActive =
                                    currUserMenu?.toLowerCase() ===
                                    subMenu["Menu_Name"]
                                      ?.toLowerCase()
                                      .replace(/\s/g, "-");

                                  return (
                                    <div
                                      key={j}
                                      onClick={() =>
                                        dynamicRoute(
                                          subMenu["Function_Name"],
                                          subMenu
                                        )
                                      }
                                      title={subMenu["Menu_Name"]}
                                      className={`py-[3px] w-full`}
                                    >
                                      <span
                                        className={`ml-5 cursor-pointer font-medium text-xs transition-colors duration-200 max-w-[60px] truncate ${
                                          isActive
                                            ? "text-blue-600 w-full"
                                            : "text-white hover:text-blue-600/40 w-full"
                                        }`}
                                      >
                                        {subMenu["Menu_Name"]}
                                      </span>
                                    </div>
                                  );
                                })}
                              </Disclosure.Panel>
                            </>
                          )}
                        </Disclosure>
                      )}
                    </li>
                  );
                })}
              </ul>
            </section>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full flex-1 sm:pl-[195px] pb-40 bg-white min-h-screen">
        <div className="fixed top-0 inset-x-0 sm:left-[195px] z-50 bg-white">
          <header className="h-[50px] xl:pr-4 px-4 flex items-center justify-between bg-white border-b border-b-gray-200">
            <div
              onClick={handleDrawerOpen}
              className="p-2 rounded-full hover:bg-gray-200 active:bg-gray-100 cursor-pointer sm:hidden"
            >
              <MenuIcon className="h-6 w-6 text-gray-600" />
            </div>

            <div>
              <GeneralSearchBar />
            </div>

            <div className="flex items-center space-x-4">
              <NotificationPane />
              <div className="hidden lg:inline">
                <SidebarModalTwo selectModal={moduleSelectHandler} />
              </div>
              <UserNameItem />
            </div>
          </header>
        </div>

        <div className="px-4 py-[70px] bg-white">{props.children}</div>
      </div>
    </div>
  );
};

export default Userlayout;
